import router from "../../router";
import { createAuth } from "vue-auth3";
import driverHttpAxios from "vue-auth3/drivers/http/axios";
import driverAuthBearer from "./bearer";
import { reactive } from "vue";
import mixins from "@/mixins";
import { RoleCode } from "./roles";

const auth = createAuth({
  plugins: {
    router,
  },
  drivers: {
    auth: driverAuthBearer,
    http: driverHttpAxios,
  },
  stores: ["storage"],
  refreshToken: {
    enabled: true,
    enabledInBackground: true,
    interval: 59,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    method: "POST",
    url: `${mixins.getBaseUrl()}/api/auth/login`,
    data: {
      grant_type: "refresh_token",
    },
  },
  loginData: {
    url: `${mixins.getBaseUrl()}/api/auth/login`,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  },
  fetchData: {
    url: `${mixins.getBaseUrl()}/api/auth/user`,
  },
});

export default auth;

interface LoginForm {
  username: string;
  password: string;
}

const loginForm: LoginForm = reactive({
  username: "",
  password: "",
});
export { loginForm };

export const authHeader = { "Referrer-Scheme": mixins.getBaseScheme() };
